import BGs from './bgs.json';

type Color = { r: number; g: number; b: number; a: number };
type BGsJson = { [key: number]: { color1: Color; color2: Color } };

export function getVXGradientBg(kongVXId: number, transparentBg?: boolean) {
  const { color1, color2 } = (BGs as BGsJson)[kongVXId];

  const rgbaColor1 = !transparentBg
    ? `rgba(${color1.r},${color1.g},${color1.b}, 1)`
    : 'rgba(255, 255, 255, 0)';

    
    const rgbaColor2 = !transparentBg
    ? `rgba(${color2.r},${color2.g},${color2.b}, 1)`
    : 'rgba(255, 255, 255, 0)';
    
  const gradient = `linear-gradient(to bottom, ${rgbaColor1} 0%,${rgbaColor2} 100%)`;

  return { gradient, color1, color2 };
}
